import { UPDATE_AI_CHATS } from '../types'

const state = {
  allAIChats: new Map(),
}

const getters = {
  allAIChats: state => state.allAIChats,
}

const mutations = {
  [UPDATE_AI_CHATS](state, aiChats) {
    state.allAIChats = aiChats
  },
}

export default {
  state,
  getters,
  mutations,
}
